'use client';

import { useTheme } from 'next-themes';
import { useEffect } from 'react';

/**
 * Swaps all favicon/icon link tags based on the active app theme.
 * Next.js generates file-based icon links like:
 *   <link rel="icon" href="/favicon.ico?favicon.xxx.ico" sizes="48x48" type="image/x-icon"/>
 *   <link rel="icon" href="/icon.png?icon.xxx.png" sizes="96x96" type="image/png"/>
 *   <link rel="icon" href="/icon.svg?icon.xxx.svg" sizes="any" type="image/svg+xml"/>
 *   <link rel="apple-touch-icon" href="/apple-icon.png?apple-icon.xxx.png" sizes="180x180" type="image/png"/>
 */
export function FaviconSwitcher() {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const isDark = resolvedTheme === 'dark';

    // All icon-related link tags
    const links = document.querySelectorAll<HTMLLinkElement>(
      'link[rel="icon"], link[rel="apple-touch-icon"]'
    );

    for (const link of links) {
      const href = link.getAttribute('href') ?? '';

      if (isDark) {
        // Light → Dark: prefix the path with /dark-
        // /favicon.ico?... → /dark-favicon.ico?...
        // /icon.png?... → /dark-icon.png?...
        if (!href.startsWith('/dark-')) {
          link.href = '/dark-' + href.slice(1);
        }
      } else {
        // Dark → Light: remove the /dark- prefix
        // /dark-favicon.ico?... → /favicon.ico?...
        if (href.startsWith('/dark-')) {
          link.href = '/' + href.slice(6);
        }
      }
    }
  }, [resolvedTheme]);

  return null;
}
